var map = {
	"./BAT-logo.png": 357,
	"./BUSD-logo.png": 358,
	"./COMP-logo.png": 359,
	"./CRV-icon.png": 608,
	"./CRV-logo.png": 360,
	"./DAI-logo.png": 361,
	"./ETH-icon.png": 609,
	"./ETH-logo.png": 362,
	"./FTM-logo.png": 363,
	"./IEARN-icon.png": 610,
	"./KNC-logo.png": 364,
	"./LEND-logo.png": 365,
	"./LINK-logo.png": 366,
	"./MANA-logo.png": 367,
	"./MKR-logo.png": 368,
	"./REP-logo.png": 369,
	"./SAI-logo.png": 370,
	"./SNX-logo.png": 371,
	"./SUSD-logo.png": 372,
	"./TUSD-logo.png": 235,
	"./USDC-icon.png": 611,
	"./USDC-logo.png": 373,
	"./USDT-icon.png": 612,
	"./USDT-logo.png": 374,
	"./YFI-logo.png": 375,
	"./ZRX-logo.png": 376,
	"./aLINK-logo.png": 377,
	"./aave.png": 613,
	"./alchemy.png": 614,
	"./bg-dark.png": 134,
	"./bg-light.png": 615,
	"./bg.png": 236,
	"./bzx.png": 616,
	"./cUSDC-logo.png": 378,
	"./cUSDT-logo.png": 379,
	"./coming-soon.png": 338,
	"./compound.png": 617,
	"./ddex.png": 618,
	"./defipulse.png": 619,
	"./defizap.png": 620,
	"./ethereum.png": 621,
	"./etherscan.png": 622,
	"./fortmaticIcon.png": 333,
	"./iDAI-logo.png": 380,
	"./kybernetwork.png": 623,
	"./learn-yearn.png": 624,
	"./ledger.png": 625,
	"./lendf.png": 626,
	"./main-background.png": 627,
	"./metamask.png": 628,
	"./portisIcon.png": 332,
	"./squarelink.png": 334,
	"./synthetix.png": 629,
	"./trezor.png": 335,
	"./truffle.png": 630,
	"./trustWallet.png": 331,
	"./uniswap.png": 631,
	"./wBTC-icon.png": 632,
	"./wBTC-logo.png": 381,
	"./yCRV-logo.png": 382,
	"./ycUSDC-logo.png": 383,
	"./ycUSDT-logo.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1424;